import React from 'react';
import { View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import {
	addDaysToRosterDate,
	formatRosterDate,
	formatShiftRange,
} from '../../../../common/utils/people/roster';
import Text from '../../../components/text/Text';
import Card from '../../../design/components/Card';
import { useTheme } from '../../../theme';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

/**
 * The next rostered shift after today, at a glance on Home.
 * Props: shift (getMyRosterShifts item), todayDateKey (YYYY-MM-DD in the tenant
 * timezone), onPress (opens My roster; omit to make the card static)
 */
const NextShiftCard = ({ shift, todayDateKey, onPress }) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	const day = shift.date === addDaysToRosterDate(todayDateKey, 1)
		? 'Tomorrow'
		: formatRosterDate(shift.date, 'ddd D MMM');
	const title = `Next shift · ${day}`;
	const detail = [formatShiftRange(shift.startMinutes, shift.endMinutes), shift.areaLabel].filter(Boolean).join(' · ');

	return (
		<Card
			style={styles.card}
			onPress={onPress}
			accessibilityLabel={`${title}, ${detail}`}
			accessibilityHint={onPress ? 'Opens My roster' : undefined}
		>
			<Feather name="calendar" size={22} color={colors.accent} />
			<View style={styles.text}>
				<Text style={styles.title} numberOfLines={1}>{title}</Text>
				<Text style={styles.detail} numberOfLines={1}>{detail}</Text>
			</View>
			{Boolean(onPress) && <Feather name="chevron-right" size={22} color={colors.iconMuted} />}
		</Card>
	);
};

const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	card: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
		paddingVertical: space.md,
		borderRadius: radius.hero,
	},
	text: {
		flex: 1,
		minWidth: 0,
		gap: space.xxs,
	},
	title: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	detail: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default NextShiftCard;
